/*
 * Globalize Culture ru-RU
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("ru-RU", "default", {
    name: "ru-RU",
    englishName: "Russian (Russia)",
    nativeName: "русский (Россия)",
    language: "ru",
    numberFormat: {
      ",": " ",
      ".": ",",
      negativeInfinity: "-бесконечность",
      positiveInfinity: "бесконечность",
      percent: {
        pattern: ["-n%", "n%"],
        ",": " ",
        ".": ","
      },
      currency: {
        pattern: ["-n$", "n$"],
        ",": " ",
        ".": ",",
        symbol: "р."
      }
    },
    calendars: {
      standard: {
        "/": ".",
        firstDay: 1,
        days: {
          names: [
            "воскресенье",
            "понедельник",
            "вторник",
            "среда",
            "четверг",
            "пятница",
            "суббота"
          ],
          namesAbbr: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
          namesShort: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]
        },
        months: {
          names: [
            "Январь",
            "Февраль",
            "Март",
            "Апрель",
            "Май",
            "Июнь",
            "Июль",
            "Август",
            "Сентябрь",
            "Октябрь",
            "Ноябрь",
            "Декабрь",
            ""
          ],
          namesAbbr: [
            "янв",
            "фев",
            "мар",
            "апр",
            "май",
            "июн",
            "июл",
            "авг",
            "сен",
            "окт",
            "ноя",
            "дек",
            ""
          ]
        },
        monthsGenitive: {
          names: [
            "января",
            "февраля",
            "марта",
            "апреля",
            "мая",
            "июня",
            "июля",
            "августа",
            "сентября",
            "октября",
            "ноября",
            "декабря",
            ""
          ],
          namesAbbr: [
            "янв",
            "фев",
            "мар",
            "апр",
            "май",
            "июн",
            "июл",
            "авг",
            "сен",
            "окт",
            "ноя",
            "дек",
            ""
          ]
        },
        AM: null,
        PM: null,
        patterns: {
          d: "dd.MM.yyyy",
          D: "d MMMM yyyy 'г.'",
          t: "H:mm",
          T: "H:mm:ss",
          f: "d MMMM yyyy 'г.' H:mm",
          F: "d MMMM yyyy 'г.' H:mm:ss",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Дополнительная справка",
      AddNewTab: "Добавить новую вкладку",
      Alerts: "Оповещения",
      ApplyFilter: "Применить фильтр",
      Approve: "Утвердить",
      Attachments: "Вложения",
      Back: "Назад",
      Basic: "Обычный",
      Between: "Между",
      Book: "Книга",
      Cancel: "Отменить",
      Checked: "Отмеченные",
      ClearFilter: "Очистить фильтр",
      Close: "Закрыть",
      CloseCancelChanges: "Закрыть и отменить изменения",
      CloseSaveChanges: "Закрыть и сохранить изменения",
      CloseTab: "Закрыть вкладку",
      ColumnPersonalization: "Персонализация столбца",
      Comments: "Комментарии",
      Confirmation: "Подтверждение",
      Contains: "Содержит",
      CreateTab: "Создать новую вкладку",
      Cut: "Вырезать",
      Delete: "Удалить",
      DiscardUndo: "Отменить/удалить",
      DisplayDropDownList: "Отобразить раскрывающийся список",
      Displaying: "Отображение: ",
      DocWord: "Документ",
      DoesNotContain: "Не содержит",
      DoesNotEndWith: "Не заканчивается на",
      DoesNotEqual: "Не равняется",
      DoesNotStartWith: "Не начинается с",
      Download: "Загрузить",
      Duplicate: "Дублировать",
      Edit: "Изменить",
      EitherSelectedorNotSelected: "Выделенный или не выделенный",
      Email: "Электронная почта",
      EndsWith: "Заканчивается на",
      EqualsStr: "Равняется",
      ExpandCollapse: "Развернуть/свернуть",
      ExportFailed: "Сбой экспорта",
      ExportToExcel: "Экспорт в Excel",
      FileInUse: "Указанный файл используется",
      FileInUseDetail:
        "Закройте файл в приложении, где он используется или укажите другое имя файла.",
      Filter: "Фильтр",
      FilterMenu: "Меню фильтра",
      FilterOptions: "Параметры фильтра",
      FilterWithinResults: "Фильтровать результаты",
      First: "Первая",
      FirstView: "Первое представление",
      Folder: "Папка",
      ForgotPassword: "Забыли пароль?",
      Forward: "Переадресовать",
      GetMoreRows: "Больше строк",
      GreaterThan: "Больше чем",
      GreaterThanOrEquals: "Больше чем или равняется",
      GridSettings: "Настройки сетки",
      GroupSelection: "Выбор группы",
      Help: "Справка",
      HideColumn: "Скрыть столбец",
      IsEmpty: "Пусто",
      IsNotEmpty: "Не пусто",
      Last: "Последняя",
      LastView: "Последнее представление",
      LaunchActivate: "Запустить/активировать",
      LessThan: "Меньше чем",
      LessThanOrEquals: "Меньше чем или равняется",
      Links: "Ссылки",
      ListTabs: "Список всех вкладок",
      LoadingItem: "Загрузка элемента ",
      Maintenance: "Обслуживание",
      Menu: "Меню",
      New: "Создать",
      Next: "Следующий",
      NextView: "Следующее представление",
      No: "Нет",
      NotChecked: "Снят",
      Notes: "Примечания",
      NotSelected: "Не выделено",
      Of: " из ",
      Ok: "OK",
      Open: "Открыть",
      Password: "Пароль",
      Paste: "Вставить",
      Phone: "Телефон",
      PleaseWait: "Подождите",
      Previous: "Предыдущий",
      PreviousView: "Предыдущее представление",
      Print: "Печать",
      Queries: "Запросы",
      Redo: "Вернуть",
      Refresh: "Обновить",
      Reject: "Отклонить",
      RememberMe: "Запомнить меня на этом компьютере",
      Reports: "Отчеты",
      Reset: "Сбросить",
      Review: "Пересмотр",
      RunFilter: "Запустить фильтр",
      RunJob: "Выполнить задание",
      Save: "Сохранить",
      SaveBeforeClosing: "Сохранить перед закрытием",
      SavedFilters: "Сохраненные фильтры",
      SaveSubmit: "Сохранить/отправить",
      ScreenDesign: "Дизайн экрана",
      Search: "Поиск",
      SelectContents: "Выделить содержимое",
      SelectDate: "Выбрать дату",
      SelectDeselect: "Выделить/очистить все",
      Selected: "Выбрано: ",
      ServerName: "Имя сервера",
      Settings: "Настройки",
      ShowFilterRow: "Показать фильтры строки",
      SignIn: "Войти",
      SortAscending: "Сортировать по возрастанию",
      SortDescending: "Сортировать по убыванию",
      Spreadsheet: "Электронная таблица",
      StartsWith: "Начинается с",
      StatusIndicator: "Индикатор статуса",
      Tasks: "Задачи",
      Today: "Сегодня",
      Translate: "Перевести",
      UserID: "Идентификатор пользователя",
      Utilities: "Служебные программы",
      Yes: "Да",
      Page: "Страница",
      Rows: "Строки",
      ShowingAll: "Показано все",
      SessionNavigation: "Навигация сеанса",
      ListAllMenuItems: "Список всех элементов меню",
      NoRecordsFound: "Записей не найдено",
      SearchTree: "Поиск дерева",
      Clear: "Очистить",
      DrillDown: "Детализация",
      Required: "Данное поле является обязательным",
      Available: "Доступно:",
      Add: "Добавить",
      MoveDown: "Переместить вниз",
      MoveUp: "Переместить вверх",
      Remove: "Удалить",
      LastYear: "В прошлом году",
      NextMonth: "В следующем месяце",
      NextWeek: "На следующей неделе",
      NextYear: "В следующем году",
      OneMonthAgo: "Один месяц назад",
      OneWeekAgo: "Одну неделю назад",
      SixMonthsAgo: "Полгода назад",
      Time: "Время",
      CannotBeSelected: "Невозможно выбрать эту строку.",
      ResetToDefault: "Восстановить значения макета по умолчанию",
      CloseOtherTabs: "Закрыть другие вкладки",
      EmailValidation: "Введите допустимый адрес электронной почты",
      UrlValidation: "Введите допустимый URL-адрес",
      EndofResults: "Конец результатов",
      More: "Дополнительно...",
      RecordsPerPage: "Число записей на странице",
      Maximize: "Развернуть",
      Minimize: "Свернуть",
      CloseAllTabs: "Закрыть все вкладки",
      QuickDates: "Быстрые даты",
      Finish: "Готово",
      SetTextColor: "Задать цвет текста",
      AttachmentRules: "Правила для вложений",
      AutoRefresh: "Автоматическое обновление",
      BarChart: "Линейчатая диаграмма",
      CopyMail: "Копировать и отправить",
      CopyUrl: "Копировать URL-адрес",
      DistributeHorizontally: "Распределить по горизонтали",
      ExpandAll: "Развернуть все",
      Generate: "Создать",
      GenerateScript: "Создать сценарий",
      NoAttachments: "Нет вложений",
      PieChart: "Круговая диаграмма",
      QuickAccess: "Быстрый доступ",
      RestoreUser: "Восстановить пользователя",
      SaveConsolidate: "Сохранить с локальной консолидацией",
      "Screen Design": "Дизайн экрана",
      SelectAll: "Выбрать все",
      SpellCheck: "Проверка орфографии",
      SubmitForApproval: "Отправить на утверждение",
      Timezone: "Часовой пояс",
      Loading: "Загрузка...",
      NewNode: "Создать узел",
      RememberSettings: "Запомнить эти настройки",
      Company: "Компания",
      Environment: "Среда",
      DontHaveAccount: "Еще не зарегестрировались?",
      ResetPassword: "Сбросить пароль",
      SignUpNow: "Вверх",
      SelectMonthYear: "Выбрать месяц и год"
    }
  });
})(this);
